<script setup>
import { computed } from 'vue';
import icons from 'Assets/icons/icons.svg'; // Adjust the path as necessary

const props = defineProps({
  /** Name of the icons (see Foundations/Icons) */
  name: {
    type: String,
    required: true,
  },
});


const svgPath = computed(() => `${icons}#${props.name}`);
</script>

<template>
  <svg class="ui-icon" focusable="false" aria-hidden="true">
    <use :href="svgPath"></use>
  </svg>
</template>

<style lang="scss">
.ui-icon {
  fill: currentColor;
  vertical-align: middle;
}
</style>
